<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='left-grid float-left'>
        <dx-data-grid ref='refQcodePrintGrid'
          :data-source='qrcodePrintInfo'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          @focused-row-changed="onSelectionChanged"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="false"
            file-name=""
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="품번"
            data-field="품번"
            sort-order='asc'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="품명"
            data-field="품명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="품목유형"
            data-field="품목유형"
            :visible='true'
          >
            <DxLookup
              :data-source="productypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>

          <DxColumn
            :allowEditing='true'
            caption="발행매수"
            data-field="매수"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="시작Key"
            data-field="seqId"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="등록일"
            sort-order='asc'
            data-field="createtime"
            dataType= 'datetime'
            format='yyyy-MM-dd HH:mm:ss'>
          </DxColumn>
         <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="발행인"
            data-field="createid"
            :visible='true'
          >
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="품번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <div class='right-grid float-left'>
        <dx-data-grid ref='refQcodePrintSubGrid'
          :data-source='qrcodePrintInfoSub'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          @rowDblClick="onRowDwClickQr"
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="false"
            file-name=""
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="품번"
            data-field="품번"
            sort-order='asc'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="품명"
            :customize-text="getGoodsName"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="일련번호"
            data-field="seqId"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            data-field=""
            cell-template="cellTemplate"
            caption='QR Code'
            alignment='center'
            :allow-sorting="false"
          >
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="품번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
          <template #cellTemplate="{ data }">
            <QRCanvas :options="getQrOption(data)"></QRCanvas>
          </template>
        </dx-data-grid>
      </div>
      <DxPopupGen v-if="qrOptions"
        :visible.sync="popupQrcode"
        :drag-enabled="true"
        :close-on-outside-click="true"
        :show-title="true"
        :width="300"
        :height="280"
        title="파레트QR"
      >
        <div style='text-align: center; margin-bottom: 10px; font-size:1.8rem; font-weight:bold;'> {{qrOptions.품번}}</div>
        <div class='qr-code-wrap' style='margin: 0 auto; width: 125px;'>
          <QRCanvas class='qr-code'  :options="qrOptions"></QRCanvas>
        </div>
      </DxPopupGen>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport } from 'devextreme-vue/data-grid'
// import AesCrypto from '../../share/service/AesCrypto'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
const { QRCanvas } = require('qrcanvas-vue')

export default {
  name: 'grcode-serial',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: 'QR코드 츨력현황'
        }
      ],
      qrcodePrintInfo: null,
      selectedRow: null,
      productypeLookup: null,
      // ********* SUB GRID ********
      qrcodePrintInfoSub: null,
      // qr popup
      popupQrcode: false,
      qrOptions: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxExport,
    QRCanvas,
    DxPopupGen
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.productypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.refreshQrCodePrintList()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    getQrOption (pCode) {
      const base64 = AppLib.getBase64SameLength(`${pCode.values[0]}/${pCode.values[2]}`)
      return { data: base64, cellSize: 2 }
    },
    getGoodsName () {
      return this.selectedRow.품명
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
        this.refreshQrCodeSub()
        console.log(this.selectedRow)
      }
    },
    refreshQrCodePrintList () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllSerialNoQrCode', {})
        .then((data) => {
          this.isLoading = false
          this.qrcodePrintInfo = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // ********* QR CODE SUB GRID
    refreshQrCodeSub () {
      let param = {
        품번: this.selectedRow.품번,
        createid: this.selectedRow.createid,
        createtime: this.selectedRow.createtime
      }
      this.$_sp.runNoEncodeFindProc('spFindAllInputQrcode', param)
        .then((data) => {
          this.qrcodePrintInfoSub = this.$_sp.MakeModel(data)
        })
    },
    onRowDwClickQr (e) {
      const base64 = AppLib.getBase64SameLength(`${e.data.품번}/${e.data.seqId}`)
      this.qrOptions = { data: base64, cellSize: 5, 품번: `${e.data.품번}/${e.data.seqId}`, 품명: e.data.품명 }
      this.popupQrcode = true
    }
  }
}
</script>

<style lang="scss">
.left-grid{
  width: 49%;
  margin-right:2%;
}
.right-grid{
  width: 49%;
}
</style>
